import atrium from "./atrium"
import breakouts, { BreakoutOne, BreakoutTwo } from "./breakouts"
import expoHall from "./expoHall"
import onDemand from "./onDemand"
import explorationZoneFn from "./explorationZone"
import { generateAuditoriums } from "./auditorium"
import assets from "../assets"
import { useContext, useEffect, useState } from "preact/hooks"
import { DayContext } from "../contexts/DayContext"
import keynotes from "./keynotes"
import interviews from "./interviews"

export const useRooms = () => {
    useContext(DayContext)

    return [
        atrium(),
        onDemand(),
        expoHall,
        breakouts(),
        BreakoutOne,
        BreakoutTwo(),
        explorationZoneFn(),
        generateAuditoriums(assets.isOnDemand()),
        keynotes,
        interviews
    ].flat()
}